module.exports = __webpack_public_path__ + "static/9-c9b058f2ac096aabbee30727acf82e9e.svg";